import { useCookie, useCurrentLocation, useCurrentOrganization, useOAuth } from "#imports";
import type { RouteParamValue } from "vue-router";
import { PUBLIC_ROUTE_NAMES, ROUTE_SWITCHER } from "~/constants/routes";
import { accessibleOrganizations } from "~/utils/accessibleOrganizations";
import { decideContextSelection } from "~/utils/contextSelection";
import { getOAuthUser } from "~/utils/oauthUserStorage";
import { isContextFreeEmployeeAdminPage } from "~/utils/globalAdmin";

export default defineNuxtRouteMiddleware(async (to) => {
  const { authConfig } = await useOAuth();

  if (PUBLIC_ROUTE_NAMES.includes(String(to.name))) {
    return;
  }

  if (to.path === authConfig.redirect?.callback || to.path === ROUTE_SWITCHER) {
    return;
  }

  const user = getOAuthUser();
  if (isContextFreeEmployeeAdminPage(to.path, user)) return;
  if (!user) {
    return;
  }

  const { currentLocationId, switchLocation } = useCurrentLocation();
  const { clearOrganization, currentOrganizationId, switchOrganization } = useCurrentOrganization();

  const locationId = to.params.locationId as RouteParamValue | undefined;
  const routeLocationId = locationId !== undefined ? Number(locationId) : undefined;

  const decision = decideContextSelection({
    organizations: accessibleOrganizations(user.organizations ?? [], user.profiles),
    profiles: user.profiles ?? [],
    currentOrganizationId: currentOrganizationId.value,
    currentLocationId: currentLocationId.value,
    routeLocationId,
  });

  if (decision.type === "select-patient") {
    clearOrganization();
    await switchLocation(decision.locationId);

    return;
  }

  if (decision.type === "select") {
    await switchOrganization(decision.organizationId);
    await switchLocation(decision.locationId);

    return;
  }

  if (decision.type === "switcher") {
    const switcherRedirectCookie = useCookie("switcher_redirect_uri");
    switcherRedirectCookie.value = to.fullPath;

    return navigateTo(ROUTE_SWITCHER);
  }
});
